var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 1.5C4.25 0.809644 4.80964 0.25 5.5 0.25H10C10.1989 0.25 10.3897 0.329018 10.5303 0.46967L15.5303 5.46967C15.671 5.61032 15.75 5.80109 15.75 6V14.5C15.75 15.1904 15.1904 15.75 14.5 15.75H5.5C4.80964 15.75 4.25 15.1904 4.25 14.5V1.5ZM10.5 6.75C9.80964 6.75 9.25 6.19036 9.25 5.5V1.75H5.75V14.25H14.25V6.75H10.5ZM10.75 2.81066L13.1893 5.25H10.75V2.81066ZM2.50182 5.75H1.75V18.25H10.25V17.5022C10.25 17.088 10.5858 16.7522 11 16.7522C11.4142 16.7522 11.75 17.088 11.75 17.5022V18.5C11.75 19.1904 11.1904 19.75 10.5 19.75H1.5C0.809645 19.75 0.25 19.1904 0.25 18.5V5.5C0.25 4.80964 0.809644 4.25 1.5 4.25H2.50182C2.91604 4.25 3.25182 4.58579 3.25182 5C3.25182 5.41421 2.91604 5.75 2.50182 5.75Z",
    fill: "#0C333B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1c5aac068a23eadcd479777d05babf9c.svg";
export { ForwardRef as ReactComponent };